import { Messages } from "../../lib/locale";

export const Italian: Messages = {
  name: "Italiano",
  helpTitle: "Come giocare",
  help1: `Ogni giorno c'è un nuovo Paese Misterioso. Il tuo obiettivo è indovinare il
   paese misterioso usando il minor numero di ipotesi. Ogni ipotesi errata
   apparirà sul globo con un colore che indica quanto sia vicino al
   Paese misterioso. Più il colore è <b>caldo</b>, più sei vicino alla risposta.`,
  help2: `Ad esempio, se il paese misterioso è  <b>Giappone</b>, appariranno i seguenti paesi
   con questi colori:`,
  help3: `Ogni giorno sarà disponibile una nuova Paese Misterioso!`,
  France: "Francia",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "Corea del Sud",
  Aux1: `<b>["Clicca", "Tap"]</b> sul globo per giocare!`,
  Aux2: "Hai una domanda?",
  Aux3: "Vai a vedere le FAQ",
  Footer1: "di Cameron Walker",
  Footer2: "Ti piace il gioco?",
  Footer3: "Offrimi un caffè",
  Loading: "Caricamento...",
  FAQTitle: "FAQ",
  q1: "1. Come viene calcolata la distanza tra la risposta e la mia ipotesi?",
  a1: "La distanza tra paesi è definita come la distanza minima tra i loro confini lungo la superficie terrestre.",
  q2: "2. Come posso giocare se sono daltonico o ipovedente?",
  a2: "È possibile attivare una modalità daltonico ad alto contrasto nelle <button>Impostazioni</button>.",
  q3: "3. In che modo il gioco decide quale è un paese valido?",
  a3: "Globe utilizza questo <a>framework</a> tper determinare cosa costituisce un'ipotesi valida.",
  q4: "4. Ci sono paesi autonomi ma non indipendenti nel gioco?",
  a4: "Alcuni territori appariranno in un colore neutro quando viene indovinato il loro paese sovrano, ad es. Groenlandia per la Danimarca. La posizione di questi territori non influisce sul colore del paese sovrano. La maggior parte dei piccoli territori non compare nel gioco, ad es. Curacao.",
  q5: "5. Ho trovato il paese misterioso di oggi! Quando potrò giocare di nuovo?",
  a5: "Il paese misterioso cambia e le tue ipotesi vengono ripristinate a mezzanotte nel tuo fuso orario.",
  q6: "6. Sono accettati nomi di paesi alternativi?",
  a6: "Esistono molti paesi con più nomi accettabili. Sono accettate alcune grafie alternative e nomi precedenti, ad es. Birmania per il Myanmar. Inoltre, gli acronimi sono accettabili per alcuni paesi con più parole, ad es. UAE per gli Emirati Arabi Uniti.",
  q7: "7. Un paese è mancante o un confine non è corretto. Cosa posso fare?",
  a7: "La geografia può essere un argomento delicato e alcuni confini sono controversi. Se ritieni che sia necessario apportare una correzione, segnala un errore su {GitHub} o inviami un DM su {Twitter}.",
  GameTitle: "Gioco",
  Game1: "Inserisci qui il nome di un paese",
  Game2: "Inserire",
  Game3:
    "Inserisci il nome di qualsiasi paese per fare il tuo primo tentativo.",
  Game4: `Scorri, <span>["click", "tap"]</span> e ingrandisci il globo per trovare il tuo prossimo tentativo..`,
  Game5: "Tentativo non valido",
  Game6: "Paese già provato",
  Game7: "Il paese misterioso è {answer}!",
  Game8: "Confine più vicino",
  StatsTitle: "Statistiche",
  Stats1: "Ultima vittoria",
  Stats2: "Tentativi di oggi",
  Stats3: "Partite vinte",
  Stats4: "Serie attuale",
  Stats5: "Serie max",
  Stats6: "Tentativo medio",
  Stats7: "Avg. Medi",
  Stats8: "Ripristina",
  Stats9: "Condividi",
  Stats10: "Sei sicuro di voler azzerare il tuo punteggio?",
  Stats11: "Statistiche cancellate.",
  Stats12: "Copiato negli appunti!",
  SettingsTitle: "Impostazioni",
  Settings1: "Tema diurno",
  Settings2: "Tema notturno",
  Settings3: "Modalità daltonici abilitata",
  Settings4: "Modalità daltonica disattivata",
  Settings5: "Paesi",
  Settings6: "Città",
  Settings7: "Lingua",
  Settings8: "Globle: Edizione Città in arrivo!",
  Settings9: "Pratica",
  Settings10: "Arcobaleno attivato",
  Settings11: "Arcobaleno disattivato",
  Answer: "Risposta",
  Closest: "Paesi più vicini",
  Guessed: "Guessed", //TODO: Translate
  PracticeMode: "Sei in modalità allenamento.",
  PracticeExit: "Esci dalla modalità allenamento",
  PracticeNew: "Nuovo gioco di pratica",
  SortByGuesses: "Sort by order of guesses", //TODO: Translate
  SortByDistance: "Sort by distance", //TODO: Translate
};
